import React, { Component } from 'react';

class Contact extends Component {
  render() {
    const { credentials } = this.props;
    return (
      <ul className="contact">
        { !!credentials.li &&
          <li>
            <a title={credentials.li} href={credentials.li}>
              <span className="fa fa-linkedin" />
            </a>
          </li>
        }
        { !!credentials.email &&
          <li>
            <a title={credentials.email} href={`mailto:${credentials.email}`}>
              <span className="fa fa-envelope" />
            </a>
          </li>
        }
        { !!credentials.tel &&
          <li>
            <a title={credentials.tel} href={`tel:${credentials.tel}`}>
              <span className="fa fa-phone" />
            </a>
          </li>
        }
      </ul>

    );
  }
};

// NEEDS TO BE EXPORTS!!
module.exports = Contact;



// WEBPACK FOOTER //
// ./templates/views/components/contact.jsx